import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { CheckCircle2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { ProfileWizard } from "@/components/ProfileWizard";
import api, { apiErrorMessage } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function Onboarding() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const [done, setDone] = useState(false);

  const complete = async (data) => {
    try {
      await api.put("/profile", data);
      setDone(true);
    } catch (e) {
      toast.error(apiErrorMessage(e));
    }
  };

  const finish = async () => {
    await refresh();
    navigate("/care");
  };

  if (done) {
    return (
      <div className="min-h-screen w-full flex justify-center bg-[#E9EEF4]">
        <div className="relative w-full max-w-[430px] min-h-screen bg-[#F8FAFC] flex flex-col items-center justify-center px-8 text-center">
          <div className="w-20 h-20 rounded-full bg-[#E8F5F1] flex items-center justify-center mb-6">
            <CheckCircle2 size={44} className="text-[#1D9E75]" />
          </div>
          <h1 className="font-head text-3xl font-extrabold text-[#0C1B33]">Profile complete</h1>
          <p className="text-slate-600 mt-3">
            Your health profile is saved securely. You're ready to plan your first confident trip.
          </p>
          <Button
            data-testid="onboarding-finish"
            onClick={finish}
            className="mt-8 w-full min-h-[56px] rounded-xl bg-[#1D9E75] hover:bg-[#16825F] text-white text-lg font-semibold"
          >
            Go to Home
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen w-full flex justify-center bg-[#E9EEF4]">
      <div className="relative w-full max-w-[430px] min-h-screen bg-[#F8FAFC] flex flex-col px-6 pt-8 pb-4">
        <h1 className="font-head text-xl font-bold text-[#0C1B33] mb-4">Set up your health profile</h1>
        <ProfileWizard onComplete={complete} submitLabel="Finish setup" />
      </div>
    </div>
  );
}
